<template>
<div>
<transition name="slide">
	<div v-show="show" class="summary-wrapper">
		<a class="bill-filter-cancel" @click="cancel">取消</a>
		<nav class="edi-nav">{{title}}</nav>
		<div class="summary-filter-shell">
			<ul class="summary-filter-ul summary-company-select-ul">
				<li><label>未确认
					<input @click.self="selectBillStatus('30', '未确认')" type="checkbox" name="selectBillStatus" v-if="selectJudge('30')" checked>
					<input @click.self="selectBillStatus('30', '未确认')" type="checkbox" name="selectBillStatus" v-else>
				</label>
				</li>
				<li><label>已同意
					<input @click.self="selectBillStatus('31', '已同意')" type="checkbox" name="selectBillStatus" v-if="selectJudge('31')" checked>
					<input @click.self="selectBillStatus('31', '已同意')" type="checkbox" name="selectBillStatus" v-else>
				</label></li>
				<li><label>已确认
					<input @click.self="selectBillStatus('32', '已确认')" type="checkbox" name="selectBillStatus" v-if="selectJudge('32')" checked>
					<input @click.self="selectBillStatus('32', '已确认')" type="checkbox" name="selectBillStatus" v-else>
				</label></li>
				<li v-if="showMakePriced">
					<label>已定价
						<input @click.self="selectBillStatus('35', '已定价')" type="checkbox" name="selectBillStatus" v-if="selectJudge('35')" checked>
						<input @click.self="selectBillStatus('35', '已定价')" type="checkbox" name="selectBillStatus" v-else>
					</label>
				</li>
			</ul>
			<a class="summary-filter-btn" @click="confirm">确定</a>
		</div>
	</div>
</transition>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		title: String,
		billStatusFlag: String,
		billStatusFont: String
	},
	data () {
		return {
			show: false,
			arr: [],
			arr2: [],
			arr3: []
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {
		this.arr3 = this.billStatusFlag.toString().split(',')
	},
	computed: {
		showMakePriced () {
			return this.billStatusFlag.indexOf('35') >= 0
		}
	},
	methods: {
		selectJudge (val) {
			if (this.arr3.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		},
		open (flag, font) {
			this.show = !this.show
			this.arr = []
			this.arr2 = []
			this.arr = flag.split(',')
			this.arr2 = font.split(',')
			if (this.arr[0] === '') {
				this.arr = []
			}
			if (this.arr2[0] === '') {
				this.arr2 = []
			}
		},
		selectBillStatus (val1, val2) {
			// this.show = false
			var index = this.arr.indexOf(val1)
			if (index === -1) {
				this.arr.push(val1)
				this.arr2.push(val2)
			} else {
				this.arr.splice(index, 1)
				this.arr2.splice(index, 1)
			}
			// window.console.log(this.arr)
			// window.console.log(this.arr2)
		},
		confirm () {
			this.show = false
			var msg = [this.arr, this.arr2]
			this.$emit('confirm', msg)
		},
		cancel () {
			this.show = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillStatusSelectL.vue?c620dca6